module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("A DAVID & CHARLES BOOK"), _c('br'), _vm._v("Copyright © David & Charles Limited 2009")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("David & Charles is an F+W Media Inc. company"), _c('br'), _vm._v("4700 East Galbraith Road"), _c('br'), _vm._v("Cincinnati, OH 45236")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First published in the UK in 2009")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Text and designs copyright © Laura Long 2009"), _c('br'), _vm._v("Photography © David & Charles 2009")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Laura Long has asserted her right to be identified as author of this work in accordance with the Copyright, Designs and Patents Act, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic or mechanical, by photocopying, recording or otherwise, without prior permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The designs in this book are copyright and must not be made for resale.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The author and publisher have made every effort to ensure that all the instructions in the book are accurate and safe, and therefore cannot accept liability for any resulting injury, damage or loss to persons or property, however it may arise.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Names of manufacturers and other products are provided for the information of readers, with no intention to infringe copyright or trademarks.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-7153-3172-9 paperback"), _c('br'), _vm._v("ISBN-10: 0-7153-3172-8 paperback")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in China by R R Donnelley"), _c('br'), _vm._v("for David & Charles"), _c('br'), _vm._v("Brunel House Newton Abbot Devon")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Commissioning Editor: Jennifer Fox-Proverbs"), _c('br'), _vm._v("Editor: Bethany Dymond"), _c('br'), _vm._v("Assistant Editor: Kate Nicholson"), _c('br'), _vm._v("Project Editor: Nicola Hodgson"), _c('br'), _vm._v("Art Editors: Prudence Rogers and Sarah Clark"), _c('br'), _vm._v("Designers: Sabine Eulau and Sarah Underhill"), _c('br'), _vm._v("Production Controllers: Beverley Richardson and Alison Smith"), _c('br'), _vm._v("Photographer: Sian Irvine"), _c('br'), _vm._v("Illustrator: Ethan Danielson")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Visit our website at "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.davidandcharles.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.davidandcharles.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("David & Charles books are available from all good bookshops; alternatively you can contact our Orderline on 0870 9908222 or write to us at FREEPOST EX2 110, D&C Direct, Newton Abbot, TQ12 4ZZ (no stamp required UK only); US customers call 800-289-0963 and Canadian customers call 800-840-5220.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d473dc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 63
// module chunks = 0